import * as ROUTES from '../../lib/routing/frontend';
import {
  canUploadInvoices,
  isAdmin,
  isAnyOutsourcer,
  isChaserOutsourcer,
  isChaserOutsourcerPlus,
  isConsultant,
  isOutsourcer,
  isSeniorStaff,
  isStaff,
  isSubUser,
  isSuperAdmin,
  isUser,
  subUserCanUploadBills,
  subUserCanViewAndDownloadInvoices,
  subUserCanViewAndDownloadReports,
} from '../helper/authorisation';

export const authByPath = (path) => {
  switch (path) {
    case ROUTES.LOGIN:
    case ROUTES.FORGOT_PASSWORD:
    case ROUTES.RESET_PASSWORD:
    case ROUTES.AUTH2FA:
    case ROUTES.NOT_FOUND:
      return true;

    case ROUTES.KITCHEN_SINK:
      return process.env.NODE_ENV !== 'production';

    case ROUTES.USERS.ALL:
    case ROUTES.USERS.SINGLE:
    case ROUTES.REPORTS.CREATE:
    case ROUTES.BILLING_CHECKLIST:
    case ROUTES.BILLING_CHECKLIST_EVENTS.ALL:
    case ROUTES.BILLING_CHECKLIST_EVENTS.SINGLE:
    case ROUTES.BILLING_CHECKLIST_EVENTS.CREATE:
    case ROUTES.CONSULTANTS.CREATE:
    case ROUTES.USERS.CREATE:
    case ROUTES.EXPORT_INVOICE_NUMBERS:
    case ROUTES.HOSPITALS.SINGLE:
    case ROUTES.HOSPITALS.CREATE:
    case ROUTES.CCSD_CODES.ALL:
    case ROUTES.CCSD_CODES.SINGLE:
    case ROUTES.CCSD_CHANGES.ALL:
    case ROUTES.HEALTH_INSURERS.ALL:
    case ROUTES.HEALTH_INSURERS.SINGLE:
    case ROUTES.INVOICE_BATCHES.BULK_ASSIGN:
    case ROUTES.INVOICES.CREATE:
    case ROUTES.INVOICES.UPDATE:
    case ROUTES.INVOICES.ALL:
    case ROUTES.INVOICES.WITH_UPDATED_INSURANCE_DETAILS:
    case ROUTES.CONSULTANT_TICKETS.BROADCAST:
    case ROUTES.INVOICES.HOSPITAL_BULK_CHASE:
    case ROUTES.EMAIL_RESPONSES.ALL:
      //      console.log('AuthByPath: '+path+' isSeniorStaff()',isSeniorStaff());
      return isSeniorStaff();

    case ROUTES.INVOICES.PARSE:
    case ROUTES.INVOICES.PARSE_SELF_PAY:
    case ROUTES.INVOICES.PARSE_HOSPITAL:
      //      console.log('AuthByPath: '+path+' isSeniorStaff()',isSeniorStaff());
      return isSeniorStaff() || canUploadInvoices();

    case ROUTES.PROBLEM_DATA.SINGLE:
    case ROUTES.PROBLEM_DATA.ALL:
    case ROUTES.PROBLEM_DATA.COMPLETED:
    case ROUTES.PROBLEM_DATA.SINGLE_EDIT:
      //      console.log('AuthByPath: '+path+'  isStaff() || isOutsourcer()', isStaff() , isOutsourcer());
      return isStaff() || isOutsourcer();

    case ROUTES.INVOICE_BATCHES.URGENT:
    case ROUTES.INVOICE_BATCHES.EMBASSY:
    case ROUTES.CONSULTANTS.ALL:
    case ROUTES.INVOICE_BATCHES.UNASSIGNED:
    case ROUTES.INVOICE_BATCHES.PROBLEM:
    case ROUTES.INVOICE_BATCHES.TO_CHECK_AND_PRICE:
    case ROUTES.CMS.REMITTANCES:
    case ROUTES.CMS.HOSPITAL:
    case ROUTES.CMS.EMBASSY:
      //      console.log('AuthByPath: '+path+' isStaff()',isStaff());
      return isStaff();

    case ROUTES.CONSULTANT_TICKETS.ALL_COMMUNICATIONS:
    case ROUTES.CONSULTANT_TICKETS.ALL_TICKETS:
    case ROUTES.CONSULTANT_TICKETS.ALL_BROADCASTS:
    case ROUTES.CONSULTANT_TICKETS.SINGLE:
    case ROUTES.CONSULTANT_TICKETS.CREATE:
      return isSeniorStaff() || isConsultant() || isSubUser(true);

    case ROUTES.HOSPITALS.ALL:
      return isUser(); // Allow all authenticated users to view hospitals list

    // MED-921. Internal users only, and this list must stay in step with Patient::READ_SECURITY
    // on the API - staff, senior staff, admins and outsourcers. Client-side users are refused
    // every patient endpoint outright, so sending them here would only produce a broken screen.
    // isStaff() and isOutsourcer() are non-strict, so admins and senior staff are covered by the
    // hierarchy just as they are on the API side.
    case ROUTES.PATIENTS.ALL:
    case ROUTES.PATIENTS.SINGLE:
      return isStaff() || isAnyOutsourcer();

    // MED-1002. Deliberately NOT in the patient group above, and narrower than it (Dan,
    // 14/09/2026). The register is working material for every internal role; this is the standing
    // record of people who owe money and were never told, which is oversight material.
    //
    // The consequence is intended: a chaser may set noShortfall on the patient screen and cannot
    // open this one. Must stay in step with SuppressedShortfall::READ_SECURITY on the API, which
    // answers 403 - a link a user cannot follow is worse than no link.
    case ROUTES.SUPPRESSED_SHORTFALLS.ALL:
      return isSeniorStaff();

    case ROUTES.CONSULTANTS.SINGLE:
      //      console.log('AuthByPath: '+path+'  isSeniorStaff() || isConsultant()', isSeniorStaff() , isConsultant());
      return isStaff() || isConsultant();

    case ROUTES.CONSULTANTS.SINGLE_FOR_SUBUSER:
      //      console.log('AuthByPath: '+path+'  isSeniorStaff() || isConsultant()', isSeniorStaff() , isConsultant());
      return isStaff() || isConsultant() || isSubUser(true);

    case ROUTES.REPORTS.ALL:
      //      console.log('AuthByPath: '+path+' isSeniorStaff() || isConsultant() || (isSubUser(true) && subUserCanViewAndDownloadReports())',isSeniorStaff() , isConsultant(),  isSubUser(true), subUserCanViewAndDownloadReports() );
      return isSeniorStaff() || isConsultant() || (isSubUser(true) && subUserCanViewAndDownloadReports());

    case ROUTES.INVOICE_BATCHES.CREATE:
      //      console.log('AuthByPath: '+path+'  isStaff() || isConsultant() || (isSubUser(true) && subUserCanUploadBills())', isStaff() , isConsultant(), isSubUser(true), subUserCanUploadBills());
      return isStaff() || isConsultant() || (isSubUser(true) && subUserCanUploadBills());

    case ROUTES.INVOICE_BATCHES.TO_ACCEPT:
    case ROUTES.INVOICE_BATCHES.TO_PROCESS:
    case ROUTES.CMS.INSURANCE:
      //      console.log('AuthByPath: '+path+'  isStaff() || isOutsourcer()', isStaff() , isOutsourcer());
      return isStaff() || isOutsourcer();

    case ROUTES.SELECT_CONSULTANT:
    case ROUTES.SUBACCOUNT.ACCEPT:
    case ROUTES.SUBACCOUNT.ACCEPT_SECURE:
      //      console.log('AuthByPath: '+path+' isSubUser(true)',isSubUser(true));
      return isSubUser(true);

    case ROUTES.INVOICE_BATCHES.SINGLE_WITH_NOTE:
    case ROUTES.INVOICE_BATCHES.SINGLE:
    case ROUTES.INVOICE_BATCHES.ALL:
      //      console.log('AuthByPath: '+path+'  (isSubUser(true) && subUserCanViewAndDownloadInvoices()) || isStaff() || isOutsourcer() || isConsultant()', isSubUser(true), subUserCanViewAndDownloadInvoices() , isStaff(), isOutsourcer() , isConsultant());
      return (isSubUser(true) && subUserCanViewAndDownloadInvoices()) || isStaff() || isOutsourcer() || isConsultant() || isChaserOutsourcerPlus();

    case ROUTES.WORK_SCHEDULE:
    case ROUTES.WORK_SCHEDULE_EVENTS.ALL:
    case ROUTES.WORK_SCHEDULE_EVENTS.SINGLE:
    case ROUTES.WORK_SCHEDULE_EVENTS.CREATE:
      return isOutsourcer() || isSeniorStaff();

    case ROUTES.INVOICES:
    case ROUTES.INVOICES.MY_ASSIGNED:
    case ROUTES.INVOICES.UNPAID:
    case ROUTES.INVOICES.SINGLE:
    case ROUTES.INVOICES.BULK_ASSIGN:
    case ROUTES.INVOICES.ESCALATED_SELF_PAY:
    case ROUTES.INVOICES.ESCALATED_HOSPITAL:
    case ROUTES.INVOICES.MISSING_CONTACT_DETAILS:
      return isChaserOutsourcer() || isStaff();

    case ROUTES.CHASER_WORK_SCHEDULE:
      return isChaserOutsourcer() || isSeniorStaff();

    case ROUTES.HOME:
    case ROUTES.PROFILE:
    case ROUTES.HELP:
    case ROUTES.TERMS:
      //      console.log('AuthByPath: '+path+'  isUser()', isUser() );
      return isUser();

    case ROUTES.SITE_SETTINGS:
    case ROUTES.INVOICES.VOIDS:
    case ROUTES.INVOICE_NOTIFICATION_EVENTS.ALL:
    case ROUTES.CASHBOOK_IMPORT:
      return isSuperAdmin() || isAdmin();
    default:
      console.error('PAGE ACCESS IS DENIED BECAUSE ROUTING AUTHORISATION IS NOT EXPLICITLY SET UP FOR ', path);
      return isSuperAdmin();
  }
};
